/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetSupportedLicenseTypes$Request {
    accountId?: number;
}

export interface GetSupportedLicenseTypes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSupportedLicenseTypesRequest = createAction<PayloadData<void, GetSupportedLicenseTypes$Request>>('GET_SUPPORTED_LICENSE_TYPES__GET_SUPPORTED_LICENSE_TYPES__REQUEST');
export const getSupportedLicenseTypesSuccess = createAction<PayloadData<Array<DictionaryItem>, GetSupportedLicenseTypes$Request>>('GET_SUPPORTED_LICENSE_TYPES__GET_SUPPORTED_LICENSE_TYPES__SUCCESS');
export const getSupportedLicenseTypesFailure = createAction<PayloadData<Error, GetSupportedLicenseTypes$Request, true>>('GET_SUPPORTED_LICENSE_TYPES__GET_SUPPORTED_LICENSE_TYPES__FAILURE');

export const getSupportedLicenseTypesActions = [
    getSupportedLicenseTypesRequest,
    getSupportedLicenseTypesSuccess,
    getSupportedLicenseTypesFailure
] as const;

/**
 * @param {number} [meta.accountId]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSupportedLicenseTypes = (meta: GetSupportedLicenseTypes$Request, config?: GetSupportedLicenseTypes$Config) => {
    const TRANSPORT_GET_PARAMS = {
        accountId: meta.accountId,
    };
    return {
        CALL_API: {
            types: getSupportedLicenseTypesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/supported-license-type`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

